export class AdapterCopyText {
    public static async copyText(text: string) {
        await navigator.clipboard.writeText(text);
    }
}